import * as React from "react";
const SvgFiRrTax = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17.625 21.782A3 3 0 0 1 16.5 22H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h4.515q.245 0 .485.023V7c0 1.654 1.346 3 3 3h5.813a1 1 0 0 0 .969-1.248 7 7 0 0 0-1.832-3.216l-3.485-3.485a6.95 6.95 0 0 0-4.95-2.05H5A5.004 5.004 0 0 0 0 5v14c0 2.757 2.243 5 5 5h11.5c.647 0 1.279-.123 1.875-.364a1 1 0 1 0-.75-1.853zM12 2.659q.571.328 1.051.806l3.485 3.485c.313.314.583.667.803 1.05H13a1 1 0 0 1-1-1zm-1.024 17.309a.796.796 0 0 0 .992-.543l.255-.825h2.969l.241.825a.8.8 0 1 0 1.536-.449l-.422-1.443c-.006-.018-.008-.037-.016-.054l-1.247-4.261c-.212-.728-.848-1.217-1.582-1.217s-1.37.489-1.583 1.216l-1.685 5.759a.8.8 0 0 0 .543.992zm2.772-6.302L14.723 17h-2.006zm9.136 5.118a.802.802 0 0 1-.683 1.217.8.8 0 0 1-.685-.384l-1.267-2.082-1.267 2.082a.8.8 0 0 1-1.1.267.8.8 0 0 1-.268-1.1l1.697-2.789-1.697-2.789a.8.8 0 0 1 .268-1.1.8.8 0 0 1 1.1.268l1.267 2.082 1.267-2.082a.8.8 0 1 1 1.368.832l-1.697 2.789zM7.2 19.2v-5.6H5.8a.8.8 0 0 1 0-1.6h4.4a.8.8 0 0 1 0 1.6H8.8v5.6a.8.8 0 1 1-1.6 0"
    />
  </svg>
);
export default SvgFiRrTax;
